export enum EmployeesListTypeSchemeEnum {
  All = 'all',
  Blacklisted = 'blacklisted',
  WhiteListed = 'whitelisted',
}
